<template>
    <div class="contact-form grid grid__base">
        <div class="grid--container">
            <div class="grid--row">
                <div class="contact-form--col grid--col">
                    <h2 class="contact-form--title" v-if="title">{{ title }}</h2>
                    <p class="contact-form--description" v-if="text">{{ text }}</p>
                    <form-data-provider v-bind="formData">
                        <generic-form class="contact-form" slot-scope="props" v-bind="props" />
                    </form-data-provider>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormDataProvider from 'framework/components/form/form-data-provider/form-data-provider';
    import GenericForm from 'framework/components/form/generic-form/generic-form';

    export default {
        components: {
            FormDataProvider,
            GenericForm,
        },
        inheritAttrs: false,
        props: {
            title: {
                type: String,
                default() {
                    return '';
                },
            },
            text: {
                type: String,
                default() {
                    return '';
                },
            },
        },
        computed: {
            formData() {
                const { fields, ...attrs } = this.$attrs;

                return {
                    fieldsets: [
                        {
                            name: null,
                            fields,
                        },
                    ],
                    ...attrs,
                };
            },
        },
    };
</script>
